export default class MedicalDocument {

	constructor (data) {
		if (data) {
			this.id = parseInt(data.id)
			this.name = data.name
			this.file = data.file
			this.responsible = data.responsible
			this.description = data.description
			this.category_id = data.categories_id
			this.category_name = data.category_name
		} else {
			this.name = ''
			this.file = ''
			this.responsible = ''
			this.description = ''
			this.category_id = ''
			this.category_name = ''
		}
	}
}



// WEBPACK FOOTER //
// ./src/classes/MedicalDocument.js